var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnorderedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_5885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.18359 12.2163C4.22174 12.2163 3.44531 12.9927 3.44531 13.9546C3.44531 14.9164 4.22174 15.6929 5.18359 15.6929C6.14544 15.6929 6.92187 14.9164 6.92187 13.9546C6.92187 12.9927 6.14544 12.2163 5.18359 12.2163ZM5.18359 5.26318C4.22174 5.26318 3.44531 6.03962 3.44531 7.00146C3.44531 7.96331 4.22174 8.73974 5.18359 8.73974C6.14544 8.73974 6.92187 7.96331 6.92187 7.00146C6.92187 6.03962 6.14544 5.26318 5.18359 5.26318ZM5.18359 19.1694C4.22174 19.1694 3.44531 19.9574 3.44531 20.9077C3.44531 21.858 4.23333 22.646 5.18359 22.646C6.13385 22.646 6.92187 21.858 6.92187 20.9077C6.92187 19.9574 6.14544 19.1694 5.18359 19.1694ZM8.66015 22.0666H24.8841V19.7489H8.66015V22.0666ZM8.66015 15.1134H24.8841V12.7957H8.66015V15.1134ZM8.66015 5.84261V8.16032H24.8841V5.84261H8.66015Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_5885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.8125,
    height: 27.8125,
    fill: "white",
    transform: "translate(0.546875 0.0478516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnorderedList);
export default __webpack_public_path__ + "static/media/unordered-list.6e34fb52d460e3c74599ccfd00b072af.svg";
export { ForwardRef as ReactComponent };